import { createViewExportStateHook } from './main.tsx';
import type { State } from './types.tsx';

export const getIsExportingViewImage = (state: State): boolean => state.isExportingViewImage;
export const getIsReadyToExportViewImage = (state: State): boolean =>
	state.isReadyToExportViewImage;

export const useIsExportingViewImage = createViewExportStateHook(getIsExportingViewImage);
export const useIsReadyToExportViewImage = createViewExportStateHook(getIsReadyToExportViewImage);
